import React, { Component } from 'react'
import { ButtonLink } from '../generic';
import { Graphic, Message, When, Where, Signature, RSVPOptions } from './preview'
import checkRequiredFields, { validString, validRadio, validPostalCode, validEmail, validUrl } from '../../helpers/check-required-fields';
import styled from 'styled-components';
import * as variables from '../../styles/variables';

export const SECTIONS = {
  "graphic": {
    title: "Event Introduction",
    buttonLabel: "Set the topic",
    requiredFields: ["topic"],
    previewComponent: Graphic,
  },
  "message": {
    title: "Invitation Message",
    buttonLabel: "Write a short message",
    requiredFields: ["invitation_message", "host_name"],
    previewComponent: Message,
  },
  "when": {
    title: "When is your gathering?",
    buttonLabel: "Set date and time",
    requiredFields: ["invitation_date", "invitation_start_time"],
    previewComponent: When,
  },
  "where": {
    title: "Where and how will you meet?",
    buttonLabel: "Set a location",
    requiredFields: [
      'event_type',
      "public_access",
      (event) => {
        // if (['online', 'online_in_person'].indexOf(event.event_type) > -1 && !validUrl(event.online_url)) {
        //   return false;
        // }
        if (['in_person', 'online_in_person'].indexOf(event.event_type) > -1 && !checkRequiredFields([
          "address_1",
          "city",
          "province",
          (event) => validPostalCode(event.postal_code),
        ], event)) {
          return false;
        }
        return true;
      },
    ],
    previewComponent: Where,
  },
  // "signature": {
  //   title: "Signature/Logo",
  //   buttonLabel: "Add your signature and/or logo",
  //   requiredFields: ["signature"],
  //   previewComponent: Signature,
  // },
  "rsvp-options": {
    title: "How should guests RSVP?",
    buttonLabel: "Choose an RSVP method",
    requiredFields: [
      "external_rsvp",
      (event) => {
        if (
          validRadio(event.external_rsvp, true) && // Another service chosen
          !(validString(event.registration_url))) { // Non-empty URL
          return false
        }
        else {
          return true
        }
      },
    ],
    previewComponent: RSVPOptions,
  },
  "profile": {
    requiredFields: [
      'firstname', 'lastname',
      (user) => validEmail(user.email),
      (user) => { return validString(user.password) ? user.password === user.repeat_password : true }
    ]
  },
  "swag": {
    requiredFields: [
      (event) => {
        if (
          (
            validRadio(event.grant_agree, true) &&
            !(validString(event.grant_amount) && validString(event.grant_purpose))
          ) ||
          (
            (validRadio(event.grant_agree, false) || event.grant_agree === null || event.grant_agree === undefined) &&
            (validString(event.grant_amount) || validString(event.grant_purpose))
          ) ||
          (
            validRadio(event.swag, true) &&
            !(validString(event.swag_address_1) && validString(event.swag_city) && validPostalCode(event.swag_postal))
          )
         ) {
          return false
        }
        else {
          return true
        }
      }
    ]
  },
  "how-to-invite" : {
    requiredFields: [
      (event) => {
        return validRadio(event.share_preferences, 3) ? (validString(event.twitter) || validString(event.instagram)) : true;
      }
    ]
  },
  "save-the-date": {
    requiredFields: []
  },
  "guest-list" : {
    requiredFields: []
  },
  "thank-you" : {
    requiredFields: []
  },
  "reminder" : {
    requiredFields: []
  },
  "share" : {
    requiredFields: []
  },
  "cancel": {
    requiredFields: [],
  },
}

const ChangeButtonWrapper = styled.div`
  margin-top: 10px;
  cursor: pointer;
`

const SectionWrap = styled.section`
  // margin-bottom: 15px;
  border: 1px solid transparent;
  padding: 20px 10px 20px;
  transition: background 0.2s ease-out;
  border-radius: 5px;
  h3 {
    margin-top: 0;
    margin-bottom: 10px;
  }
  &.unfilled {
    background: rgba(255,255,255,0.5);
    text-align: center;
  }
  &.hovered {
    // border: 1px solid ${variables.colours.olive};
    background: rgba(255,255,255,1);
  }
  &.graphic {
    margin-bottom: 10px;
    &.filled {
      padding-top: 10px;
    }
    &.unfilled {
      // margin-top: 10px;
    }
  }
  &.when {
    &.filled {
      a {
        margin-left: 55px;
      }
    }
  }
  &.where {
    // padding-bottom: 10px;
    &.filled {
      a {
        margin-left: 47px;
      }
    }
  }
  &.message {
    &.filled {
      padding-top: 10px;
    }
    &.unfilled {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  &.rsvp-options {
    margin-bottom: 10px;
    &.unfilled {
      margin-top: 10px;
    }
  }
`

class Section extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filled: checkRequiredFields(SECTIONS[this.props.slug].requiredFields, this.props.userEvent),
      hover: false,
    }
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }
  onMouseEnter() {
    this.setState({
      hover: true,
    })
  }
  onMouseLeave() {
    this.setState({
      hover: false,
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      filled: checkRequiredFields(SECTIONS[nextProps.slug].requiredFields, nextProps.userEvent),
    })
  }

  render() {
    const { slug, className } = this.props
    const { filled } = this.state
    const url = `/host/hub/forms/${slug}`
    const { title, buttonLabel } = SECTIONS[slug]
    const PreviewComponent = SECTIONS[slug].previewComponent

    if (!this.props.userEvent) {
      return (<div>Loading...</div>)
    }

    return (
      <SectionWrap style={this.props.style} className={(className || '') + ` ${slug} ` + (filled ? ' filled ' : ' unfilled ') + (this.state.hover ? ' hovered' : '')}>
        {!filled && (
          <React.Fragment>
            <h3>{title}</h3>
            <ButtonLink secondary="true" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} to={{ pathname: url, state: { modal: true } }}>{buttonLabel}</ButtonLink>
          </React.Fragment>
        )}
        {filled && (
          <React.Fragment>
            {PreviewComponent ? <PreviewComponent userEvent={this.props.userEvent} /> : <div><br/>Preview</div>}
            <ChangeButtonWrapper>
              <ButtonLink secondary="true" small="true" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} to={{ pathname: url, state: { modal: true } }}>Change</ButtonLink>
            </ChangeButtonWrapper>
          </React.Fragment>
        )}
      </SectionWrap>
    )
  }
}

export default Section

